<script>
import Layout from '@layouts/main.vue'
import { authComputed } from '@state/helpers'
import analyticsService from '@utils/analytics-service'

export default {
  page: {
    title: 'Autobuy',
    meta: [
      { name: 'description', content: 'Autobuy this listing on Inventory Bot' },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      dialog: false,
      showSubscriptions: false,
    }
  },
  computed: {
    ...authComputed,
    showDropCounter() {
      let show = true
      const remainingDrops = parseInt(this.currentUser.dropCount) || 0
      if (this.currentUser.activeSubscription === true && remainingDrops <= 0) {
        show = false
      }

      return show
    },
    appUrl() {
      const keys = Object.keys(this.$route.query || {})
      const params = new URLSearchParams()
      for (let i = 0; i < keys.length; i += 1) {
        params.set(keys[i], this.$route.query[keys[i]])
      }
      return `https://app.inventorybot.io/app/track?${params.toString()}`
    },
  },
  mounted() {
    analyticsService.trackPageView('Home')
  },
  methods: {
    openDropDialog(showSubscriptions) {
      analyticsService.trackAction('Opened Get More Drops')
      console.log(showSubscriptions)
      this.showSubscriptions = showSubscriptions
      this.dialog = true
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.container">
      <div>
        <h2
          >You'll need the app to Autobuy that! Join us on the IB App!<br />You
          can find us on the App Store and Google Play!</h2
        >
      </div>
      <br />
      <p
        >Once you have the app installed, you can try that same link again, or
        on iOS tap the "Open" button up top.</p
      >
      <br />
      <br />

      <div>
        <a href="https://apps.apple.com/tm/app/inventory-bot/id1599747004">
          <img
            src="https://inventorybot.io/wp-content/uploads/2021/07/btn2.png"
          />
        </a>
      </div>
      <br />
      <div>
        <a
          href="https://play.google.com/store/apps/details?id=io.inventorybot.app"
        >
          <img
            src="https://inventorybot.io/wp-content/uploads/2021/07/btn1.png"
          />
        </a>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.dropContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  margin-top: 80px;
  margin-bottom: 60px;
  cursor: pointer;
}

.graphSubtitle {
  font-size: 12px;
}

.getMoreContainer {
  align-self: flex-end;
}

.getMoreLabel {
  font-size: 15px;
}

.dropCount {
  font-size: 180px;
}

.dropLabel {
  font-size: 25px;
}
.dropHistoryContainer {
  margin-top: 15px;
}

.appScreenshot {
  max-width: 350px;
}
</style>
